"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _excel = require("@/utils/excel");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _index4 = _interopRequireDefault(require("@/components/Mask/index.vue"));
var _clients = require("@/api/clients");
var _admin = require("@/store/modules/admin");
var _admins = require("@/api/admins");
var _leads = require("@/api/leads");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.selectedClientId = null;
    this.selectedColumn = '';
    this.securityQuestion = '';
    this.securityAnswer = '';
    this.securityDialogVisible = false;
    this.downloadLoading = false;
    this.listQuery = {
      page: 1,
      limit: 10,
      name: undefined,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        name: '$contL',
        enabled: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  created() {
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
    this.getAdminDetails();
  }
  getContactName(row) {
    if (!row.contacts || !row.contacts.length) return '-';
    const primary = row.contacts.find(c => c.isPrimary) || row.contacts[0];
    const fullName = `${primary.firstName || ''} ${primary.lastName || ''}`.trim();
    const designation = primary.designation ? ` (${primary.designation})` : '';
    return fullName + designation;
  }
  async getList(id = null, column = null) {
    try {
      this.listLoading = true;
      const data = await (0, _clients.getClients)((0, _index2.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      const maskingData = {
        dataColumn: column,
        adminId: this.loggedInAdmin.id,
        clientId: id
      };
      for (const client of this.list) {
        if (id && client.id === id && column === 'emailAddress') {
          await (0, _leads.addMaskingRequest)(maskingData);
        } else if (client.emailAddress) {
          client.emailAddress = this.maskSensitiveInfo(client.emailAddress);
        }
        if (id && client.id === id && column === 'name') {
          await (0, _leads.addMaskingRequest)(maskingData);
        } else if (client.name) {
          client.name = this.maskSensitiveInfo(client.name);
        }
        if (id && client.id === id && column === 'contactNumber') {
          await (0, _leads.addMaskingRequest)(maskingData);
        } else if (client.contactNumber) {
          client.contactNumber = this.maskSensitiveInfo(client.contactNumber);
        }
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  maskSensitiveInfo(input) {
    if (input.includes('@')) {
      // If it's an email
      const atIndex = input.indexOf('@');
      return input.slice(0, atIndex - 3) + '*' + input.slice(atIndex);
    } else if (input.match(/^\d+$/)) {
      // If it's a mobile number
      return input.slice(0, -4).replace(/\d/g, '*') + input.slice(-4);
    } else {
      // Otherwise, assuming it's a full name
      const nameParts = input.split(' ');
      return nameParts.map((part, index) => index === 0 ? part : '*'.repeat(part.length)).join(' ');
    }
  }
  async getAdminDetails() {
    const adminId = _admin.AdminModule.id;
    this.loggedInAdmin = await (0, _admins.getAdminById)(adminId);
    this.securityQuestion = this.loggedInAdmin.securityQuestion.title;
  }
  showSecurityDialog(id, column) {
    this.selectedClientId = id;
    this.selectedColumn = column;
    this.securityDialogVisible = true;
  }
  verifySecurityAnswer() {
    if (this.securityAnswer === this.loggedInAdmin.securityAnswer) {
      this.getList(this.selectedClientId, this.selectedColumn);
    }
    this.securityDialogVisible = false;
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = (0, _index2.formatJson)(filterVal, this.list);
    (0, _excel.exportJson2Excel)(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientList ',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default,
    Mask: _index4.default
  }
})], default_1);
var _default = exports.default = default_1;